'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _NavApp = require('../pages/NavApp');

var _NavApp2 = _interopRequireDefault(_NavApp);

var _UIIllustration = require('UIComponents/image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    _classCallCheck(this, Home);

    return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }

  _createClass(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '345492',
          formId: '284f8009-5979-4e6f-9bcf-3045f8665762',
          target: '.home > .form'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _NavApp2.default,
        { title: 'growthhub' },
        _react2.default.createElement(
          'div',
          { className: 'home' },
          _react2.default.createElement(
            'div',
            { className: 'illustration' },
            _react2.default.createElement(_UIIllustration2.default, { name: 'evergreen', width: 300 })
          ),
          _react2.default.createElement('div', { className: 'form' })
        )
      );
    }
  }]);

  return Home;
}(_react.Component);

exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/Home.js
// module id = 446
// module chunks = 171